module.exports = __webpack_public_path__ + "img/likeMarcado.080fde89.svg";